import { render } from "./ArtistSkeleton.vue?vue&type=template&id=63dd5fee&scoped=true"
const script = {}

import "./ArtistSkeleton.vue?vue&type=style&index=0&id=63dd5fee&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dd5fee"]])

export default __exports__